<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Левая часть -->
      <div class="footer-left">
        <TextField
          tag="span"
          weight="600"
          size="14px"
          class="footer-description"
        >
          {{ $t("landing.footerTitle") }}
        </TextField>
        <div class="footer-logo">
          <span v-html="logoZerek" />
          <div class="inner-text">
            <TextField tag="p" weight="900" class="logo-title">ZEREK</TextField>
            <TextField tag="span" size="14px" weight="600" class="logo-subtitle">
              {{ $t("landing.zerekTitle") }}
            </TextField>
          </div>
        </div>
        <div class="footer-copyright inner-text">
          <TextField size="14px">{{ $t("landing.edusSystems") }}</TextField>
          <TextField size="14px">{{ $t("landing.rights") }}</TextField>
        </div>
      </div>

      <!-- Центральная часть -->
      <div class="footer-center">
        <nav class="footer-nav">
          <a href="/">{{ $t("landing.footerAboutCompany") }}</a>
          <a href="/vacancies">{{ $t("landing.vacancies") }}</a>
          <a href="/">{{ $t("landing.reviewsTitle") }}</a>
        </nav>
        <div class="footer-socials">
          <v-btn
            icon
            :href="'https://api.whatsapp.com/send/?phone=77777304090&text&type=phone_number&app_absent=0'"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="@/assets/whatsapp.svg" alt="WhatsApp" />
          </v-btn>
          <v-btn
            icon
            :href="'https://www.instagram.com/edus.kz/#'"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="@/assets/instagram.svg" alt="Instagram" />
          </v-btn>
        </div>
      </div>

      <!-- Правая часть -->
      <div class="footer-right">
        <div class="footer-right-logo">
          <!-- <TextField tag="p" size="19px" weight="900" class="footer-title">{{
            $t("landing.footerConsultationTitle")
          }}</TextField>
          <form class="footer-form">
            <input type="email" :placeholder="$t('landing.footerFormLabel')" />
            <button type="submit">{{ $t("landing.footerSendBtn") }}</button>
          </form> -->
          <a href="#" class="center-link"
            ><TextField
              :enableHover="true"
              hoverColor="#3F51B5"
              weight="800"
              color="#0B43F1"
              >{{ $t("landing.forCenters") }}
            </TextField>
            <img src="@/assets/arrow-icon.svg" alt="Arrow"
          /></a>
        </div>
        <div class="footer-right-support">
          <ul class="footer-policy">
            <li>
              <a href="/useConditions">{{ $t("landing.useConditions") }}</a>
            </li>
            <li>
              <a href="/privacyPolicy">{{ $t("landing.privacyPolicy") }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import logoZerek from "!!raw-loader!@/assets/logo_zerek.svg";

export default {
  name: "Footer",
  data() {
    return {
      logoZerek,
    };
  },
};
</script>

<style scoped>
::v-deep.footer-logo span svg {
  width: 40px;
  height: 40px;
}

.inner-text {
  display: flex;
  flex-direction: column;
}

.center-link {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 30px;
}

.footer {
  background-size: 150% 150%;
  padding: 50px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: "";
  position: absolute;
  bottom: -125px;
  left: -125px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(247, 152, 36, 0.22) 0%, rgba(247, 152, 36, 0.22) 80%, rgba(247, 152, 36, 0.22) 100%);
  filter: blur(30px);
  z-index: 1;
}

.footer::after {
  content: "";
  position: absolute;
  top: -10px;
  right: -70px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(11, 67, 241, 0.22) 0%, rgba(11, 67, 241, 0.22) 80%, rgba(11, 67, 241, 0.22) 100%);
  filter: blur(30px);
  z-index: 1;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  width: 75%;
  gap: 40px;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
}

.footer-left {
  flex: 1;
  min-width: 250px;
  max-width: 268px;
  display: flex;
  flex-direction: column;
}

.footer-description {
  font-size: 14px;
  margin-bottom: 20px;
  font-weight: 600;
  max-width: 230px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 50px;
  margin-bottom: 20px;
}

.footer-logo p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.footer-logo small {
  font-size: 12px;
}

.footer-copyright {
  font-size: 14px;
  color: #31393c;
}

.footer-center {
  flex: 1;
  min-width: 200px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.footer-nav {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.footer-nav a {
  font-size: 14px;
  color: #333;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.footer-nav a:hover {
  color: #0056b3;
}

.footer-socials {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: auto;
}

.footer-socials img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.footer-socials img:hover {
  transform: scale(1.1);
}

.footer-right {
  flex: 1;
  min-width: 250px;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  height: auto;
}

.footer-right p {
  font-size: 19px;
}

.footer-title {
  margin-bottom: 10px;
}

.footer-form {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.footer-form input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  max-width: 215px;
}

.footer-form button {
  padding: 10px;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  max-width: 88px;
  display: flex;
  justify-content: center;
}

.footer-link {
  display: inline-block;
  font-size: 14px;
  color: #3f51b5;
  text-decoration: none;
  margin-bottom: 30px;
}

.footer-link:hover {
  text-decoration: underline;
}

.footer-policy {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-right-support {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  min-height: 150px;
}

.footer-policy a {
  font-size: 12px;
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-policy a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.footer-support {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  color: #3f51b5;
  text-decoration: none;
  border: 1px solid #3f51b5;
  padding: 8px 16px;
  border-radius: 4px;
  text-align: center;
  transition: all 0.3s ease;
  align-self: flex-start;
  margin-top: auto;
}

.footer-support:hover {
  background-color: #3f51b5;
  color: #ffffff;
}

.logo-subtitle {
  font-size: 12px !important;
  line-height: 1.2;
  max-width: 120px;
  white-space: normal;
  text-align: left;
}

@media (max-width: 1100px) {
  .footer-container {
    gap: 30px;
    justify-content: space-around;
  }
  
  .footer-left,
  .footer-center,
  .footer-right {
    flex: 0 1 auto;
  }
}

@media (max-width: 968px) {
  .footer-container {
    gap: 40px;
  }
  
  .footer-left {
    flex: 1 0 100%;
    max-width: 100%;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
  }
  
  .footer-description {
    max-width: 100%;
  }
  
  .footer-logo {
    justify-content: center;
    margin-top: 20px;
  }
  
  .footer-center {
    flex: 1;
    order: 2;
  }
  
  .footer-right {
    flex: 1;
    order: 3;
    max-width: 100%;
    align-items: center;
  }
  
  .footer-policy {
    align-items: center;
  }
  
  .footer-support {
    align-self: center;
    margin-top: 20px;
  }
  
  .logo-subtitle {
    text-align: center;
    max-width: 150px;
  }

  .footer-copyright span {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 20px;
  }
  
  .footer-container {
    flex-direction: column;
    gap: 40px;
  }
  
  .footer-left,
  .footer-center,
  .footer-right {
    width: 100%;
    max-width: 100%;
    text-align: center;
  }
  
  .footer-nav {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  .footer-socials {
    margin-top: 20px;
  }
  
  .center-link {
    justify-content: center;
    margin-bottom: 25px;
  }
  
  .footer-right-logo {
    margin-bottom: 25px;
  }
  
  .footer-right-support {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .footer-policy {
    margin-bottom: 20px;
  }
  
  .footer::before {
    width: 200px;
    height: 200px;
    bottom: -80px;
    left: -80px;
  }
  
  .footer::after {
    width: 200px;
    height: 200px;
    top: -60px;
    right: -80px;
  }
  
  .logo-subtitle {
    max-width: 120px;
    font-size: 11px !important;
  }

  .footer-description {
    text-align: center;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 640px) {
  .footer {
    margin-bottom: 85px;
  }

  .footer-nav {
    flex-direction: column;
    gap: 15px;
  }
  
  .footer-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 15px;
  }
  
  .footer-logo .inner-text {
    align-items: center;
    text-align: center;
  }
  
  .footer-logo span {
    display: flex;
    justify-content: center;
  }
  
  .logo-subtitle {
    max-width: 100%;
    text-align: center;
    font-size: 12px !important;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 30px 15px;
  }
  
  .footer-container {
    gap: 35px;
  }
  
  .footer-logo {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  
  .footer-socials {
    gap: 12px;
  }
  
  .footer-socials img {
    width: 22px;
    height: 22px;
  }
  
  .footer::before {
    width: 150px;
    height: 150px;
    bottom: -50px;
    left: -50px;
  }
  
  .footer::after {
    width: 150px;
    height: 150px;
    top: -30px;
    right: -50px;
  }

  .logo-subtitle {
    font-size: 11px !important;
    line-height: 1.1;
    padding: 0 auto;
  }
}

@media (max-width: 375px) {
  .footer {
    padding: 25px 12px;
  }
  
  .footer-container {
    gap: 30px;
  }
  
  .footer-nav a {
    font-size: 13px;
  }
  
  .footer-support {
    font-size: 13px;
    padding: 6px 14px;
  }
  
  .footer-socials img {
    width: 20px;
    height: 20px;
  }
}
</style>
